import React from 'react'

import { FormattedMessage } from 'react-intl'
import AspectContainer from '../../../../components/AspectContainer/AspectContainer'
// @ts-expect-error — importing js
import { Button } from '../../../../components'

import './DigitalEventCard.scss'
import { useWebinarColors } from '../../../../hooks/useWebinarColors'
import { WebinarPanelComponent } from '../index'

interface DigitalEventCardProps {
  title: string
  thumbnailUrl: string
  numberOfSessions: number
  numberOfLiveSessions?: number
  onClick?: () => void
}

const DigitalEventCard = ({
  title,
  thumbnailUrl,
  numberOfSessions,
  numberOfLiveSessions,
  onClick = () => {},
}: DigitalEventCardProps) => {
  const numberOfSessionsPrefix = numberOfSessions === 1 ? 'session' : 'sessions'
  const webinarColors = useWebinarColors()

  return (
    <WebinarPanelComponent>
      <div className="content-enclosure">
        <div className="thumbnail">
          <AspectContainer>
            <img src={thumbnailUrl} alt="thumbnail" />
          </AspectContainer>
        </div>
        <div className="info-enclosure">
          <div className="title">{title}</div>
          <div className="count">
            <FormattedMessage
              defaultMessage="{count} {numberOfSessionsPrefix}"
              values={{
                count: numberOfSessions,
                numberOfSessionsPrefix,
              }}
            />
            {!!numberOfLiveSessions && numberOfLiveSessions > 0 && (
              <FormattedMessage
                defaultMessage=" — {count} live"
                values={{ count: numberOfLiveSessions }}
              />
            )}
          </div>
        </div>
      </div>
      <Button
        type="button"
        style={{
          backgroundColor: webinarColors.accent,
          color: webinarColors.accent.contrast,
          borderColor: 'transparent',
        }}
        onClick={onClick}
        round
      >
        See sessions
      </Button>
    </WebinarPanelComponent>
  )
}

export default DigitalEventCard
